import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { STEP_EXECUTION_METADATA_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_step_execution_metadata_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { StepExecutionLogs } from '@/types/stepExecutions.ts';

const useRetrieveStepExecutionMetadata = (
  stepExecutionId?: string,
): UseQueryResult<StepExecutionLogs, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: STEP_EXECUTION_METADATA_KEY(automationId, stepExecutionId),
    queryFn: async () => {
      const response = await apiClient.get<StepExecutionLogs>(
        get_step_execution_metadata_url(stepExecutionId),
      );
      return response.data;
    },
    enabled: !!stepExecutionId,
  });
};

export default useRetrieveStepExecutionMetadata;
